// @core/api/endpoints/product/list_my_product_profiles.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListProductProfilesResponse,
} from '../../../types/product';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/product';

/**
 * List my profiles across all products
 * Returns all product profiles belonging to the authenticated user. Useful for displaying a unified view of the user's presence across products.
 */
export async function ListMyProductProfiles(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListProductProfilesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/products/profiles`;
  const requestOptions = options;
  return client.get<ListProductProfilesResponse>(requestPath, { ...requestOptions, params });
}
